import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel';

export default class RecipeCarousel {
    private readonly container: HTMLElement;
    private readonly media: MediaQueryList;
    private embla: EmblaCarouselType | null = null;

    constructor(container: HTMLElement) {
        this.container = container;
        this.media = matchMedia('(max-width: 799px)');
        this.media.addListener(() => this.update());
        this.update();
    }

    update() {
        if (this.media.matches) {
            this.create();
        } else {
            this.destroy();
        }
    }

    create() {
        if (this.embla) {
            this.embla.reInit();
        } else {
            this.embla = EmblaCarousel(this.container, {
                containScroll: 'trimSnaps',
            });
        }
    }

    destroy() {
        if (this.embla) {
            this.embla.destroy();
        }
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLElement>(selector)).map(container => {
            return new RecipeCarousel(container);
        });
    }
}
